'use client';

import {createElement, forwardRef, Fragment, useEffect, useRef} from 'react';
import {createRoot} from 'react-dom/client';
import PropTypes from 'prop-types';
import {autocomplete} from '@algolia/autocomplete-js';

const addQaIdLocator = (containerRef, selector, qaId) => {
  const el = containerRef.current.querySelector(selector);
  if (el) {
    el.setAttribute('data-qa-id', qaId);
  }
};

export const AutoCompleteSearchBar = forwardRef(({classNames, ...props}, ref) => {
  const panelRootRef = useRef(null);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!ref.current) {
      return undefined;
    }
    const search = autocomplete({
      container: ref.current,
      detachedMediaQuery: 'none',
      renderer: {createElement, Fragment, render: () => {}},
      renderNoResults({render: renderElem, root}) {
        renderElem(null, root);
      },
      render({elements, html}, root) {
        const {suggestion, template} = elements;
        if (!panelRootRef.current || rootRef.current !== root) {
          rootRef.current = root;

          panelRootRef.current?.unmount();
          panelRootRef.current = createRoot(root);
        }
        panelRootRef.current.render(
          html`<div className=${classNames.panelLayout}>
            <div>
              <div>${suggestion}</div>
              <div>${template}</div>
            </div>
          </div>`
        );
      },
      classNames,
      ...props,
    });

    addQaIdLocator(ref, '.search-bar__input', 'input-search-bar');
    addQaIdLocator(ref, '.aa-SubmitButton.search-bar__input--icons', 'submitSearchQueryIconButton');

    return () => {
      search.destroy();
    };
  }, [props]);

  return <div id="autocomplete-input" data-qa-id="meganavSearchInput" ref={ref} />;
});

AutoCompleteSearchBar.propTypes = {
  classNames: PropTypes.objectOf(PropTypes.string),
};
